// Libs
import gsap from 'gsap'

// Helpers
import MyEmitter from './MyEmitter'

// Utils
import params from '../utils/params'

// Synced with SceneLogo.ANIMATION_SLIDE_DURATION
const ANIMATION_SLIDE_DURATION = 1.3


let UUID = 0

export default class Slider{

    constructor(sliderContainer, workElements, workCenter, isMobile, lists){

        this.uuid = UUID++

        // variables

        this.isMobile = isMobile

        // list of clients and directors
        this.textLists = lists

        this.workElements = workElements
        this.workCenter = workCenter
        this.sliderContainer = sliderContainer

        this.titlesContainer = sliderContainer.querySelector(".js-titles")

        this.clientText = sliderContainer.querySelector(".js-bg-client")
        this.directorText = sliderContainer.querySelector(".js-bg-director")

        this.videoElements = this.workElements.map(w => w.querySelector(!this.isMobile ? "video" : "img"))

        this.sliderIndex = 0
        this.count = workElements.length

        this.isSliding = false

        this.raf = null

        // for SceneLogo
        this.wordSize = []

        for(let i = 0; i < this.textLists.clientList.length; i++){
            let max = Math.max(
                this.textLists.clientList[i].length,
                this.textLists.directorList[i].length
            )
            this.wordSize.push(max)
        }

        this.workElements[this.sliderIndex].classList.add("current")


        // set initial texts

        let initialClient = this.textLists.clientList[this.sliderIndex]
        let initialDirector = this.textLists.directorList[this.sliderIndex]

        this.clientText.innerText = initialClient
        this.directorText.innerText = initialDirector
    }

    /** Hooks */

    onSlided(nextIndex){

    }

    start(){

        // set current video and play
        this.workElements[this.sliderIndex].classList.add("current")

        // desktop only
        if(!this.isMobile){
            this.videoElements[this.sliderIndex].play()
        }

        // set current work titles

        // desktop only
        if(!this.isMobile){
            this.raf = requestAnimationFrame(() => this.listenPlayRate())
        }
    }

    stop(){
        cancelAnimationFrame(this.raf)
    }

    /** Events */

    onVideoEnded(){
        this.handleSlide(+1)
    }

    listenPlayRate(){

        let {currentTime, duration} = this.videoElements[this.sliderIndex]

        let limit = duration - ANIMATION_SLIDE_DURATION - .01
        let percent = currentTime / limit

        // trigger end 
        if(currentTime >= limit){
            this.onVideoEnded()
        }
        
        // animate background

        let backgroundPositionX = (100 - percent * 100) + "%"

        this.clientText.style.backgroundPositionX = backgroundPositionX
        this.directorText.style.backgroundPositionX = backgroundPositionX

        this.raf = requestAnimationFrame(() => this.listenPlayRate())
    }

    /** Process */

    handleSlide(direction){

        let nextIndex = this.sliderIndex + direction
        // loop index for the infinite slider
        let clampedNextIndex = nextIndex >= this.count ? 0 : nextIndex < 0 ? this.count - 1 : nextIndex

        this.animateSlide(clampedNextIndex, nextIndex - this.sliderIndex)
    }

    scaleMiddleUI(nextIndex){

        let scale = (this.wordSize[nextIndex] / 11) * .63
        scale = Math.max(1, scale)

        // scale cylinder
        MyEmitter.emit(params.Events.onSliderSlide, scale)

        // no auto scale in mobile mode
        if(this.isMobile) return

        // scale work center
        let workCenterWidthReference = 25

        gsap.to(this.workCenter, {
            ease: params.Animations.easeDecrement,
            duration: ANIMATION_SLIDE_DURATION,
            
            width: workCenterWidthReference * scale + "vw"
        })
    }
  
    animateSlide(nextIndex, direction){

        if(this.isSliding) return;

        // Emit slide event
        // Allow CylinderLogo to sync
        this.scaleMiddleUI(nextIndex)


        this.isSliding = true

        let nextClient = this.textLists.clientList[nextIndex]
        let nextDirector = this.textLists.directorList[nextIndex]

        let currentVideoItem = this.workElements[this.sliderIndex]
        let currentVideo = this.videoElements[this.sliderIndex]

        let nextVideoItem = this.workElements[nextIndex]
        let nextVideo = this.videoElements[nextIndex]

        let tl = gsap.timeline({
            onStart: () => {

                this.onSlided(nextIndex)

                // set next video and play it
                nextVideoItem.classList.add("next")

                if(!this.isMobile){
                    nextVideo.currentTime = 0
                    nextVideo.play()
                }

                // set nextIndex
                this.sliderIndex = nextIndex
            },
            onComplete: () => {
            
                // set next state slider
                nextVideoItem.classList.remove("next")
                nextVideoItem.classList.add("current")
                currentVideoItem.classList.remove("current")

                // pause current(previous) video
                if(!this.isMobile){
                    currentVideo.pause()
                }

                // can finally slide again
                this.isSliding = false
            }
        })

        tl.to([this.clientText, this.directorText], {
            duration: .25,
            opacity: 0,
            repeat: 1,
            yoyo: true,
            onRepeat: () => {
                this.clientText.innerText = nextClient
                this.directorText.innerText = nextDirector
            }
        }, 0)

        tl.to(currentVideoItem, {
            duration: ANIMATION_SLIDE_DURATION,

            x: -direction * 50 + "%"
        }, 0)

        tl.fromTo(nextVideoItem, {
            x: direction * 100 + "%"
        }, {
            duration: ANIMATION_SLIDE_DURATION,

            x: 0
        }, 0)
    }

}